import { render, staticRenderFns } from "./FormGetCustomerId.vue?vue&type=template&id=b3875968&scoped=true&"
import script from "./FormGetCustomerId.vue?vue&type=script&lang=js&"
export * from "./FormGetCustomerId.vue?vue&type=script&lang=js&"
import style0 from "./FormGetCustomerId.vue?vue&type=style&index=0&id=b3875968&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3875968",
  null
  
)

export default component.exports